
import { Component, OnInit, Inject, OnDestroy, ViewChild } from "@angular/core";
declare var $: any;
import { Router, ActivatedRoute } from "@angular/router";

// import { ReCaptchaV3Service } from "ng-recaptcha";

// import { AngularFireDatabase } from "@angular/fire/database";

import { Login } from "./model/login.model";
import { AuthService } from "../../services/auth.service";
import { ServiceService } from "../../services/service.service";
import { MessagingService } from "../../services/messaging.service";
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  dataObj = new Login();
  error: boolean = false;
  success: boolean = false;
  errMessage: string = "";
  successMessage: string = "";
  validation: boolean = false;
  formSubmission: boolean = false;
  formData = new FormData();
  status: string = "";
  id: string = "";
  apiResponse: boolean = false;
  body: any;
  serverName: any = "apple";

  @ViewChild("form") form: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ServiceService,
    private auth: AuthService,
    private messageService: MessagingService,
    private deviceService: DeviceDetectorService
    // private angularFireDB: AngularFireDatabase,
    // private recaptchaV3Service: ReCaptchaV3Service
  ) {
    //if (localStorage.getItem("isloggedIn") === "true")
    if (
      localStorage.getItem("isloggedIn") === "true" &&
      sessionStorage.getItem("UserLogin") === "Yes"
    ) {
      //this.router.navigate(["/waitinglist"]);
      //this.router.navigate(["/business/list/1"]);
      this.router.navigate(["/familymember/view-profile"]);
    } else {
      this.auth.logoutUser();
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
    // document.body.classList.add("bodyclsss");
    if (localStorage.getItem("error") === "true") {
      this.error = true;
      this.errMessage = localStorage.getItem("errMessage");
      localStorage.removeItem("error");
      localStorage.removeItem("errMessage");
    }

    if (localStorage.getItem("success") === "true") {
      this.success = true;
      this.successMessage = localStorage.getItem("successMessage");
      localStorage.removeItem("success");
      localStorage.removeItem("successMessage");
    }

    // this.executeImportantAction();
    // get the current ip address of the user
    this.service.getIpAddress().subscribe((data: any) => {
      this.serverName = data.ip;
      
      this.serverName = this.service.servers.get(this.serverName) ? this.service.servers.get(this.serverName) : this.serverName;
    });
  }
 
  removeSpaces() {
    if (this.dataObj.userid) this.dataObj.userid = this.dataObj.userid.trim();
  }

  submitForm() {
    this.formSubmission = true;
    this.validation = true;
    this.error = false;
    this.errMessage = "";
    if (this.form.valid) {
      $(".overlay-loading").show();
      this.service.findTenant('public/find-tenant', this.dataObj.userid).subscribe(res => {
        localStorage.setItem("user-tenant", JSON.stringify(res));
        this.firstLogin(res['scac']);
      }, error => {
        $(".overlay-loading").hide();
        this.error = true;
        this.errMessage=error.error.message;
      });
      
    }

  }

  private firstLogin(scac: string): void {
    $(".overlay-loading").show();
    this.body = `grant_type=password&username=${this.dataObj.userid}&password=${this.dataObj.password}`;

    this.service.firstLogin(this.body,'oauth/token', scac,4000).subscribe((response) => {
      localStorage.setItem("authenticationObject", JSON.stringify(response));
      localStorage.setItem("access_token", response.access_token);
      localStorage.setItem("user_name", this.dataObj.userid);
      sessionStorage.setItem("user_name", this.dataObj.userid);
      sessionStorage.setItem("user_password", this.dataObj.password);
      this.service.getLoggedInUserDetails().subscribe(data => {
        localStorage.setItem('user_scac', null != data.scac ? data.scac : data.domain);
        localStorage.setItem('user_name', data.username);
        
        localStorage.setItem('user_authority', data.authorities ? data.authorities[0].authority 
        : data.user.role.role? data.user.role.role: 'ROLE_SUPER_ADMIN');
        localStorage.setItem('user', JSON.stringify(data));
        localStorage.setItem('role_modules', JSON.stringify(data.roleModules));
        this.service.allowOrderFromPortal().subscribe(allowOrderFromPortal => {
          localStorage.setItem('allowOrderFromPortal', allowOrderFromPortal+"");
        })
        

        $(".overlay-loading").hide();
        // this.router.navigate(["/dashboard"]);
        this.redirectToRespectivePage();
      });
     
    }, error =>{
      $(".overlay-loading").hide();
      this.error = true;
      this.errMessage=error.error.error_description;
    });
      
  }

  private redirectToRespectivePage(): void {
    
    let authority = localStorage.getItem('user_authority');
    if(JSON.parse(localStorage.getItem('user'))?.user?.email == 'dispatch@prestigewash.com'){

      if(this.deviceService.isMobile()){
        // true for mobile device
        // document.write("mobile device");
        this.router.navigate(['/dashboard/inventory-tank-levels']);
      }else{
        // false for not mobile device
        // document.write("not mobile device");
        this.router.navigate(['/dashboard/station-inventory']);
      }
        // this.router.navigate(['/stickreadings']);
        
    } else if (authority == 'ROLE_WHO_OWNS_IT' || authority == 'ROLE_WHO_RECEIVES_IT') {
        this.router.navigate(['/dashboard']);
    } else if (localStorage.getItem('user_authority') == 'ROLE_TENANT_ADMIN') {
        // this.router.navigate(['/googlemaps/fleet-status']);
        this.router.navigate(['/dashboard']);
    } else if (localStorage.getItem('user_authority') == 'ROLE_FLEET_MAINTENANCE') {
        this.router.navigate(['/mechanic']);
    } 
    
    else {
        this.router.navigate(['/dashboard']);
    }
  }


}
